<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="drawRow.type === 'edit' ? '编辑角色' : $t('system::rbac::新增角色')"
    @close="onChange"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <el-form :model="form" :rules="rules" label-position="left" label-width="100px" ref="form">
      <el-form-item prop="roleName" :label="$t('system::rbac::角色姓名')">
        <el-input v-model="form.roleName" :maxlength="12" show-word-limit></el-input>
      </el-form-item>
      <el-form-item prop="roleDesc" :label="$t('system::rbac::角色描述')">
        <el-input v-model="form.roleDesc" :maxlength="100" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div class="footer_class" slot="footer" style="text-align: center; display: block">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="sumbit" type="primary" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addRole, editRole } from '@/server/system'
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      if (bool) {
        if (this.drawRow.type === 'edit') {
          const { roleDesc, roleName, roleId } = this.drawRow.data
          this.form = { roleDesc, roleName, roleId }
        }
      }
      this.dialogVisible = bool
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        roleDesc: '',
        roleName: ''
      },
      rules: {
        roleName: [{ required: true, message: this.$t('system::rbac::请输入角色姓名'), trigger: 'blur' }],
        roleDesc: [{ required: true, message: this.$t('system::rbac::请输入角色描述'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    async save() {
      this.loading = true
      let data
      if (this.drawRow.type === 'add') {
        data = await addRole(this.form)
      } else {
        data = await editRole(this.form)
      }
      if (data.data.code === this.$code) {
        this.$message.success(
          this.drawRow.type === 'add' ? this.$t('system::tip::add_success') : this.$t('system::tip::save_success')
        )
        this.onChange()
        this.$emit('refresh')
      }
      this.loading = false
    },
    sumbit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    onChange() {
      this.$refs.form.resetFields()
      this.form = { roleName: '', roleDesc: '' }
      this.$emit('change', false)
    }
  }
}
</script>
<style scoped lang="scss"></style>
